import { useState, useMemo } from "react";

import { Column, Row, ToggleSpacedButtons } from "@bridgesplit/ui";
import { isLeverageLoop } from "@bridgesplit/abf-react";
import { RatesComparisonPeriodSelect, useRatesComparisonPeriodSelect } from "app/components/common";

import { useLoopContext } from "../LoopContext";
import { LoopApyHistory, LoopPerformanceHistory } from "./charts";

enum OpenChart {
    Performance = "Historical Performance",
    Apy = "Historical APY"
}

export default function LoopDetailCharts() {
    const { loopExpanded } = useLoopContext();
    const periodController = useRatesComparisonPeriodSelect("LoopDetailChartsPeriod");

    const isLeverage = useMemo(() => isLeverageLoop(loopExpanded), [loopExpanded]);
    const chartOptions = useMemo(() => getChartOptions(isLeverage), [isLeverage]);

    const [openChart, setOpenChart] = useState<OpenChart>(isLeverage ? OpenChart.Performance : OpenChart.Apy);

    return (
        <Column spacing={2}>
            <Row spaceBetween>
                <ToggleSpacedButtons size="small" value={openChart} setValue={setOpenChart} options={chartOptions} />
                <RatesComparisonPeriodSelect {...periodController} />
            </Row>
            {openChart === OpenChart.Apy && <LoopApyHistory />}
            {isLeverage && openChart === OpenChart.Performance && <LoopPerformanceHistory />}
        </Column>
    );
}

function getChartOptions(isLeverage: boolean) {
    return isLeverage ? [{ value: OpenChart.Performance }, { value: OpenChart.Apy }] : [{ value: OpenChart.Apy }];
}
